core-select {
  display: block;
}

.core-select {
  display: flex;
}

.core-select .select-wrapper {
  position: relative;
}

/* override cursor on label in inside format because of user agent styles */
.core-select .select-wrapper:not(.select-disabled .select-wrapper):hover, .core-select.select-format--inside .select-wrapper:not(.select-disabled .select-wrapper) .select-header label:hover {
  cursor: pointer;
}

.core-select.select-disabled .select-field {
  pointer-events: none;
  background: var(--color-global-all-disabled-soft);
  color: var(--color-global-all-disabled-strong);
  border-color: transparent;
}

.core-select.select-disabled:hover {
  cursor: not-allowed;
}

.core-select.select-format--inside .select-field {
  padding: calc(var(--number-spacing-3xsmall) - 1px) calc(var(--number-spacing-2xsmall) - 1px);
}

.core-select.select-format--outside .select-field, .core-select.select-format--aside .select-field, .core-select.select-format--hidden .select-field  {
  padding: calc(var(--number-spacing-2xsmall) - 1px);
}

.core-select.select-format--outside {
  flex-direction: column;
}

.core-select.select-format--aside {
  flex-direction: row;
}

.core-select.select-header {
  display: flex;
  flex-direction: column;
}

.core-select.select-format--outside .select-header {
  padding: var(--number-spacing-none) var(--number-spacing-4xsmall) var(--number-spacing-4xsmall) var(--number-spacing-4xsmall);
}

.core-select.select-format--aside .select-header {
  flex: 1;
  padding-right: var(--number-spacing-small);
  justify-content: center;
}

.core-select.select-format--aside .select-wrapper {
  flex: 1;
}

.core-select.select-format--inside .select-wrapper, .core-select.select-format--outside .select-wrapper {
  width: 100%;
}

.core-select .label {
  display: flex;
  align-items: center;
  color: var(--color-edition-content-default);
}

.core-select .description {
  color: var(--color-neutral-content-medium);
}

.core-select.select-in-error .label {
  color: var(--color-status-content-error);
}

.core-select .field-requirement {
  padding-left: var(--number-spacing-4xsmall);
}

.core-select .error-message {
  padding: var(--number-spacing-4xsmall) var(--number-spacing-4xsmall) var(--number-spacing-none) var(--number-spacing-4xsmall);
  color: var(--color-status-content-error);
}

.core-select .select-field {
  display: flex;
  align-items: center;
  border-radius: var(--number-radius-small);
  border: 1px solid var(--color-edition-border-default);
  background: var(--color-edition-background-default);
  color: var(--color-neutral-content-strong);
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-select .field-placeholder {
  color: var(--color-neutral-content-strong);
  opacity: 0.65;
}

.core-select .select-field:not(.select-in-error .select-field):hover, .core-select .select-field:not(.select-in-error .select-field):focus-visible, .core-select.select--open .select-field {
  border: 1px solid var(--color-edition-border-interacting);
  color: var(--color-neutral-content-strong);
}

.core-select .select-field:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
}

.core-select .select-field:not(.select-in-error .select-field):hover .label,
.core-select .select-field:not(.select-in-error .select-field):focus-visible .label,
.core-select.select--open .label,
.core-select:has(.select-field:not(.select-in-error .select-field):hover) .label,
.core-select:has(.select-field:not(.select-in-error .select-field):focus-visible) .label {
  color: var(--color-edition-content-interacting);
}

.core-select .field-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.core-select .field-indicator {
  display: flex;
  align-items: center;
}

.core-select.select--closed .open-indicator {
  transform: rotate(0deg);
  transition: transform var(--motion-duration-medium) var(--motion-easing-exit);
}

.core-select.select--open .open-indicator {
  transform: rotate(-180deg);
  transition: transform var(--motion-duration-medium) var(--motion-easing-enter);
}

.core-select .icon-box, .core-select-option-list .icon-box {
  display: flex;
  padding: var(--number-spacing-5xsmall);
  animation: appear var(--motion-duration-medium) var(--motion-easing-enter);
}

.core-select .core-select-option-list {
  display: none;
}

/* option list */
.core-select-option-list {
  position: absolute;
  top: 0;
  left: 0;
  width: max-content;
  z-index: 9999;
  width: calc(100% - var(--number-spacing-2xsmall));
  overflow-y: auto;
  border-radius: var(--number-radius-large);
  padding: var(--number-spacing-4xsmall);
  background-color: var(--color-neutral-background-strong);
  text-align: left;
  box-shadow: var(--effect-drop-medium);
  opacity: 1;
  transform: translateY(0), translateX(0);
  transition: opacity var(--motion-duration-medium) var(--motion-easing-move),
  transform var(--motion-duration-medium) var(--motion-easing-move);
}

.core-select-option-list.option-list--hidden {
  opacity: 0;
}

.core-select-option-list.option-list--hidden.option-list--top {
  transform: translateY(0.5rem);
}

.core-select-option-list.option-list--hidden.option-list--bottom {
  transform: translateY(-0.5rem);
}

.core-select-option-list ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.core-select-option-list > ul {
  max-height: 21.5rem;
}

.core-select-option-list .option {
  display: flex;
  align-items: center;
  border-radius: var(--number-radius-small);
  padding: var(--number-spacing-2xsmall);
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-select-option-list .option:not(.option--disabled) {
  cursor: pointer;
}

.core-select-option-list .option:not(.option--disabled):not(.option--selected) {
  color: var(--color-selection-secondary-content-default);
}

.core-select-option-list .option--disabled {
  color: var(--color-global-all-disabled-strong);
}

.core-select-option-list .option--disabled:hover {
  cursor: not-allowed;
}

.core-select-option-list .option .option-content {
  flex-grow: 1;
}

.core-select-option-list .option:not(.option--disabled):not(.option--selected):hover, .core-select-option-list .option:not(.option--disabled):not(.option--selected):focus-visible {
  background-color: var(--color-selection-secondary-background-interacting);
}

.core-select-option-list .option:focus-visible  {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
}

.core-select-option-list .option--selected {
  background-color: var(--color-selection-secondary-background-selected);
  color: var(--color-selection-secondary-content-selected);
}

/* Section */
.core-select-option-list .section-title {
  display: flex;
  padding: var(--number-spacing-small) var(--number-spacing-2xsmall) var(--number-spacing-2xsmall) var(--number-spacing-2xsmall);
  color: var(--color-neutral-content-strong);
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
